var map = {
	"./battery_1.png": 476,
	"./battery_2.png": 935,
	"./battery_3.png": 190,
	"./break.png": 710,
	"./charcoal_1.png": 446,
	"./coalgas_1.png": 351,
	"./diesel_1.png": 385,
	"./electric_1.png": 738,
	"./electric_1_1.png": 822,
	"./electric_1_2.png": 615,
	"./electric_1_3.png": 348,
	"./electric_2.png": 745,
	"./electric_2_1.png": 73,
	"./electric_2_2.png": 138,
	"./electric_2_3.png": 643,
	"./electric_3.png": 992,
	"./electric_4.png": 215,
	"./electric_4_1.png": 203,
	"./electric_4_2.png": 344,
	"./electric_6.png": 885,
	"./electric_7.png": 756,
	"./gasoline_1.png": 731,
	"./gasoline_2.png": 872,
	"./hydrogen_1.png": 267,
	"./hydrogen_2.png": 424,
	"./naturalgas_1.png": 993,
	"./statistics_2.png": 917,
	"./title.png": 201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;